<template>
    <transition name="centerMove" appear>
        <div class="centerFlex" id="centerFlex">
            <div class="flex-container" :style="{'min-height': pageMinHeight}">
                <!-- 会员首页 -->
                <menberPage v-show="selectPage == 1"></menberPage>
                <!-- 积分任务 -->
                <integralTask v-show="selectPage == 2"></integralTask>
                <!-- 积分乐园 -->
                <integralPlay v-show="selectPage == 3"></integralPlay>
                <!-- 积分商城 -->
                <integralShop v-show="selectPage == 4"></integralShop>
                <!-- 个人中心 -->
                <personalCenter v-show="selectPage == 5"></personalCenter>
                <!-- 底部栏 -->
                <div class="navList">
                    <div class="nav" v-for="(item, index) in navList" :key="'nav' + index">
                        <img v-if="selectPage != item.id" :src="item.default" alt="">
                        <img v-if="selectPage == item.id" :src="item.active" alt="">
                        <span :class="{'active': selectPage == item.id}">{{item.name}}</span>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import menberPage from './menberPage'
import integralTask from './integralTask'
import integralPlay from './integralPlay'
import integralShop from './integralShop'
import personalCenter from './personalCenter'

export default {
    components: {
        menberPage,
        integralTask,
        integralPlay,
        integralShop,
        personalCenter
    },
    data() {
        return {
            navList: [
                {name: '会员首页', id: 1, default: require('@/assets/images/nav_hysy_n.png'), active: require('@/assets/images/nav_hysy_s.png')},
                {name: '积分任务', id: 2, default: require('@/assets/images/nav_jfrw_n.png'), active: require('@/assets/images/nav_jfrw_s.png')},
                {name: '积分乐园', id: 3, default: require('@/assets/images/nav_jfly_n.png'), active: require('@/assets/images/nav_jfly_s.png')},
                {name: '积分商城', id: 4, default: require('@/assets/images/nav_jfsc_n.png'), active: require('@/assets/images/nav_jfsc_s.png')},
                {name: '个人中心', id: 5, default: require('@/assets/images/nav_grzx_n.png'), active: require('@/assets/images/nav_grzx_s.png')},
            ],
            pageMinHeight: 0,
        }
    },
    computed: {
        ...mapState(["selectPage"])
    },
    mounted() {
        this.pageMinHeight = (document.getElementById('centerFlex').clientHeight - 80)+ 'px';
    },
}
</script>

<style lang="scss" scoped>
.centerFlex {
    display: flex;
    box-sizing: border-box;
    padding: 40px 68px 40px 0;
    width: 575px;
    overflow: scroll;
    &.centerMove-enter-active {
        transition: all 1s;
        &::-webkit-scrollbar-thumb {
            background: #ddd;
        }
    }
    &::-webkit-scrollbar {
        width: 6px;
        height: 10px;
    }
    &::-webkit-scrollbar-track {
        background: rgba(246, 246, 246, 1);
        border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
        // background: #ddd;
        background: #F5F7FA;
        border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #ddd;
    }
    .flex-container {
        display: flex;
        flex-direction: column;
        .navList {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: 100%;
            height: 68px;
            background-color: #fff;
            .nav {
                display: flex;
                flex-direction: column;
                align-items: center;
                cursor: pointer;
                .active {
                    color: #DC4E40;
                }
                img {
                    width: 32px;
                    height: 32px;
                }
                span {
                    color: #000;
                    font-size: 10px;
                }
            }
        }
    }
}
.centerMove-enter {
    transform: translateY(100%);
}
.centerMove-enter-to {
    transform: translateY(0);
}
</style>
<style lang="scss">
.flip-list-move {
    transition: transform .6s;
}
</style>